/**
 * Camera for the playable boards. The camera sits on the -z side (see `scene.ts`) and looks at the origin.
 *
 * Desktop and tablets keep the 3D look with a slightly flatter pitch than the old 45 degrees. A phone gets a
 * near top-down view that fills the canvas, so every square (the far rank included) stays a thumb-sized
 * tap target: at 390px wide a square is >= 44px tall instead of 15px.
 */
export interface BoardCamera {
  readonly position: readonly [number, number, number];
  readonly fov: number;
}

export const BOARD_CAMERA_WIDE: BoardCamera = { position: [0, 10.8, -4.8], fov: 45 };
export const BOARD_CAMERA_PHONE: BoardCamera = { position: [0, 9.5, -0.4], fov: 45 };

/** Backgammon's board is wider than it is tall (10.6 units of frame), so it backs off to fit the width. */
export const BACKGAMMON_CAMERA_PHONE: BoardCamera = { position: [0, 10.4, -0.8], fov: 45 };
export const BACKGAMMON_CAMERA_WIDE: BoardCamera = { position: [0, 9, -9], fov: 45 };

export function boardCamera(phone: boolean, game: 'chess' | 'backgammon' = 'chess'): BoardCamera {
  if (game === 'backgammon') return phone ? BACKGAMMON_CAMERA_PHONE : BACKGAMMON_CAMERA_WIDE;
  return phone ? BOARD_CAMERA_PHONE : BOARD_CAMERA_WIDE;
}
